import React from 'react';
import { ChevronDownIcon } from '@fiverr-private/icons';
import { grey_900 } from '@fiverr-private/sass/helpers/index';

export const ArrowIcon = () => <ChevronDownIcon color={grey_900} size={12} />;
